<template lang="pug">
  .faq-block(itemscope itemtype="https://schema.org/FAQPage")
    h3.faq-block__title {{ getTitleText }}
    .faq-block__list
      FaqItem(v-for="faq_item in questionAnswersList" :key="faq_item.question" :faqItem="faq_item")
</template>
<script>

import FaqItem from "./FaqItem";
export default {
  name: "FaqDumb",
  components: {
    FaqItem,
  },
  props: {
    questionAnswersList: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    getTitleText() {
      return this.title ? this.title : this.$t("faq.default_title");
    },
  },
};
</script>
<style lang="scss">
@import "../style/faq";
</style>